module.exports = __webpack_public_path__ + "static/media/con_spa_res_pla.8e7054a7.png";